module.exports = __webpack_public_path__ + "static/WEDDING E&M-60-5f62966eed829dd0f3d2728f6588e216.jpg";